import React, { useRef } from 'react';

import useApi from '@/hooks/useApi';

import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { TInteractionButtonSendClick } from '@/services/requests/Interactions/types';
import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

import { getVisibleCardsIdByElement } from '@/helpers/HtmlHelper/getVisibleCardsIdByElement';
import { getValue } from '@/helpers/GetValueHelper';

type TProps = {
  data: TRecommendation;
  tabName: string;
  layout?: string;
};

export const Button = React.memo((props: TProps) => {
  const { data, tabName, layout } = props;
  const { id, cta, config } = data;
  const { Api, traceId } = useApi();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const label = getValue(cta, '[0].label', '') as string;
  const link = getValue(cta, '[0].link', '') as string;

  const handleButtonClick = async () => {
    await dispatchInteraction<TInteractionButtonSendClick>(Api, 'button-send', {
      recommendationId: id,
      cards: getVisibleCardsIdByElement(
        buttonRef.current as HTMLElement,
        'button-send',
      ),
      tabName,
    });

    if (layout === '6' && config.params) {
      const { contentId, planMiles, planType, promotionalChannel } =
        config.params;
      const eventData = new CustomEvent('smls-update-club-open', {
        detail: {
          contentId,
          promotionalChannel,
          planType,
          planMiles,
          recommendationId: id,
          traceId,
        },
      });
      window.dispatchEvent(eventData);
    } else if (layout === '7' && config.params) {
      const { nm_bank, nm_variant1, nm_variant2 } = config.params;
      const eventData = new CustomEvent('smls-bank-card-modals-open', {
        detail: {
          recommendationId: id,
          traceId,
          bank: nm_bank,
          variant1: nm_variant1,
          variant2: nm_variant2,
        },
      });
      window.dispatchEvent(eventData);
    } else {
      window.location.href = link;
    }
  };

  if (!label) return null;

  return (
    <button
      data-testid="t1-button"
      ref={buttonRef}
      type="button"
      onClick={handleButtonClick}
      className="vitrine-template1__button"
    >
      {label}
    </button>
  );
});
